<template>
  <v-flex
    md8
  >
    <MaterialCard
      color="green"
      full-width
    >
      <v-data-table
        :headers="headers"
        :items="result"
        disable-initial-sort
        :rows-per-page-items="[10, 25, 50, 100]"
        rows-per-page-text="1ページあたり"
        no-data-text="条件を設定し検索してください"
      >
        <template
          slot="headerCell"
          slot-scope="{ header }"
        >
          <span
            class="subheading font-weight-light text--darken-3"
            v-text="header.text"
          />
        </template>
        <template
          slot="items"
          slot-scope="{ item }"
        >
          <tr @click.stop="selectCustomer($event, item)">
            <td> {{ item.code }} </td>
            <td> {{ item.name }} </td>
            <td> {{ item.areaName }} </td>
            <td> {{ item.sensors.join(', ') }} </td>
          </tr>
        </template>
        <template
          v-if="loading"
          slot="no-data"
        >
          <td />
          <td />
          <td>
            <v-progress-circular
              class="my-3"
              indeterminate
              color="metalBlue"
              width="2"
            />
          </td>
          <td />
        </template>
      </v-data-table>
    </MaterialCard>
  </v-flex>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      headers: [
        { text: '顧客番号', value: 'code', sortable: true },
        { text: '名称', value: 'name', sortable: false },
        { text: 'エリア', value: 'area', sortable: true },
        { text: 'センサー', value: 'sensors[0]', sortable: true }
      ],
      selectedElem: null
    }
  },
  computed: {
    ...mapState('customers', ['result', 'loading'])
  },
  watch: {
    loading (val) {
      if (val && this.selectedElem) {
        this.selectedElem.removeAttribute('active')
        this.selectedElem = null
        this.$emit('select-customer', null)
      }
    }
  },
  methods: {
    selectCustomer ({ currentTarget }, item) {
      if (this.selectedElem) {
        this.selectedElem.removeAttribute('active')
      }
      currentTarget.setAttribute('active', true)
      this.selectedElem = currentTarget

      this.$emit('select-customer', item)
    }
  }
}
</script>
